import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isCEDeadlineClicked: false,
    isBriefDetailsValid: undefined,
    isSaveAsDraftClicked: false,
    isEvalDetailsValid:undefined,
    isProducerDetailsValid: undefined,
    isBriefDetailsPartiallyFilled: false,
    isEvaluationPartiallyFilled: false,
    isProducerPartiallyFilled: false
}

export const createBriefSlice = createSlice({
    name: 'createBrief',
    initialState,
    reducers: {
        setIsCEDeadlineClicked: (state, action) => {
            state.isCEDeadlineClicked = action.payload.isCEDeadlineClicked;
        },
        setIsBriefDetailsInValid: (state, action) => {
            state.isBriefDetailsValid = action.payload.isBriefDetailsValid;
        },
        setIsSaveAsDraftClicked: (state, action) => {
            state.isSaveAsDraftClicked = action.payload.isSaveAsDraftClicked;
        },
        setIsEvalDetailsValid: (state, action) => {
            state.isEvalDetailsValid = action.payload.isEvalDetailsValid;
        },
        setIsProducerDetailsValid:(state, action)=>{
            state.isProducerDetailsValid=action.payload.isProducerDetailsValid;
        },
        setIsBriefDetailsAtLeastPartiallyFilled: (state, action) => {
            state.isBriefDetailsPartiallyFilled = action.payload.isBriefDetailsPartiallyFilled
        },
        setIsEvalDetailsAtLeastPartiallyFilled: (state, action) => {
            state.isEvaluationPartiallyFilled = action.payload.isEvaluationPartiallyFilled
        },
        setIsProducerDetailsAtLeastPartiallyFilled: (state, action) => {
            state.isProducerPartiallyFilled = action.payload.isProducerPartiallyFilled
        }
    }
})

export const { setIsCEDeadlineClicked, setIsBriefDetailsInValid,
    setIsSaveAsDraftClicked, setIsEvalDetailsValid, setIsProducerDetailsValid,
    setIsBriefDetailsAtLeastPartiallyFilled, setIsEvalDetailsAtLeastPartiallyFilled,
    setIsProducerDetailsAtLeastPartiallyFilled } = createBriefSlice.actions

export default createBriefSlice.reducer